import { render } from "./VacanciesTemplate.vue?vue&type=template&id=6b14ddf3"
import script from "./VacanciesTemplate.vue?vue&type=script&lang=js"
export * from "./VacanciesTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__